<div class="modal-header">
  <h1 class="modal-title" id="modal-basic-title">{{ 'envelope.signatory.modalOrder.headerText' | translate}}</h1>
  <button class="cdx-button cdx-button--icon" aria-label="Close" (click)="modalClose()">
    <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','times']"></fa-icon>
  </button>
</div>
<div class="modal-body">
  <h3>{{ 'envelope.signatory.modalOrder.descriptionText' | translate}}</h3>
  <br>
  <div class="row m-0 mb-3 d-flex w-100 justify-content-between align-items-center">
    <h4>{{ 'envelope.signatory.modalOrder.descriptionchoice' | translate}}</h4>
    <div [ngClass]="orderDisabled ? 'orderDisabled' : ''">
      <cdx-toggle-switch [toggledOn]="orderEnabled" 
        (toggle)="onChangeEnabled($event)">
      </cdx-toggle-switch>
    </div>
  </div>
  <div *ngIf="orderEnabled" class="pt-3">
    <div *ngFor="let element of filteredElements; let i=index">
      <div class="row m-0 mb-1 d-flex w-100 justify-content-between align-items-center">
        <div class="col-3">
          <input type="number" class="form-control"
            [value]="element?.order" min="{{ orderMin }}" max="{{ orderMax }}" maxlength="2" (keypress)="processKeyPress($event);"
            (change)="processChange(i, $event, element)" [disabled]="element.disabled" >
        </div>
        <div class="col-9">
          <input type="text" class="form-control" placeholder="{{ [element?.name, element?.mail].join(' | ') }}" disabled>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer pr-3">
  <button class="cdx-button cdx-button--tertiary ml-0" (click)="modalClose()">
    <span class="cdx-button__text">{{ 'cancel' | translate | uppercase }}</span>
  </button>
  <button class="cdx-button cdx-button--primary ml-0" [disabled]="!canSave" (click)="modalSubmit()">
    <span class="cdx-button__text">{{ 'change' | translate | uppercase}}</span>
  </button>
</div>
